var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoundation = function SvgFoundation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M39.201 9.973c0 5.509-4.45 9.974-9.94 9.974s-9.942-4.465-9.942-9.974C19.32 4.465 23.77 0 29.26 0s9.941 4.465 9.941 9.973M10.211.95a.473.473 0 0 1 .82 0L21.176 18.58a.475.475 0 0 1-.41.713H.474a.475.475 0 0 1-.41-.713zM41.448.594a.95.95 0 0 0-.947.95v16.86c0 .524.424.949.947.949h16.804a.95.95 0 0 0 .947-.95V1.543a.95.95 0 0 0-.947-.95z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M39.201 9.973c0 5.509-4.45 9.974-9.94 9.974s-9.942-4.465-9.942-9.974C19.32 4.465 23.77 0 29.26 0s9.941 4.465 9.941 9.973M10.211.95a.473.473 0 0 1 .82 0L21.176 18.58a.475.475 0 0 1-.41.713H.474a.475.475 0 0 1-.41-.713zM41.448.594a.95.95 0 0 0-.947.95v16.86c0 .524.424.949.947.949h16.804a.95.95 0 0 0 .947-.95V1.543a.95.95 0 0 0-.947-.95z",
    clipRule: "evenodd"
  })));
};
export default SvgFoundation;